export default "\n<div class=\"map\" #mapContainer></div>\n<div *ngIf=showPlaceholder class=\"overlay\">\n  &nbsp;\n</div>\n\n";